<template>
    <v-btn rounded depressed color="#F9F9F9" :class="['text-capitalize border-btn', {'fixed': fixed}]" small @click="onBackClick">
        <v-icon color="accent" left>$left_arrow</v-icon>
        <span class="text-btn">
            {{ $t('common.back') }}
        </span>
    </v-btn>
</template>

<script>
export default {
    name: "BackButton",
    props: {
        route: {
            type: Object,
            default: null,
        },
        fixed: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        onBackClick() {
            const vm = this
            if(!vm.route) return vm.$router.back()
            vm.$router.push(vm.route)
        }
    }
}
</script>

<style scoped>

.text-btn {
    color: #03342C;
}

.fixed {
    position: fixed;
    z-index: 99;
}

.border-btn {
    border: 1px solid var(--v-backGroundPrimary-base) !important;
}

</style>